/**
 * Returns an array of the accreditor name and URL for programs
 * @param {*} accreditor
 * @returns
 */
const destructureAccreditor = (accreditor) => {
  let accreditorName = "";
  let accreditorURL = "";
  if (accreditor) {
    const parsed = accreditor.split("-");
    accreditorName = parsed[0];
    accreditorURL = parsed[1];
  }
  return [accreditorName, accreditorURL];
};

export { destructureAccreditor };
